import apiClient from "utils/ApiClient";
import { SITES } from "configurations/Urls";

const RecipeUsageService = {
  async getRecipeUsageByPlantedAcresId(siteId, plantedAcresId, params = "") {
    const response = await apiClient.get(
      `${SITES}/${siteId}/planted-crops/${plantedAcresId}/chemical-usage?${params}`
    );
    return response.data;
  },
  async addRecipeUsage(siteId, plantedAcresId, payload) {
    const response = await apiClient.post(
      `${SITES}/${siteId}/planted-crops/${plantedAcresId}/chemical-usage`,
      payload
    );
    return response.data;
  },
  async updateRecipeUsage(siteId, plantedAcresId, recipeUsageId, payload) {
    const response = await apiClient.put(
      `${SITES}/${siteId}/planted-crops/${plantedAcresId}/chemical-usage/${recipeUsageId}`,
      payload
    );
    return response.data;
  },
  async deleteRecipeUsage(siteId, plantedAcresId, recipeUsageId) {
    const response = await apiClient.delete(
      `${SITES}/${siteId}/planted-crops/${plantedAcresId}/chemical-usage/${recipeUsageId}`
    );
    return response.data;
  },
};

export default RecipeUsageService;
